import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {},
    grid: {
      display: 'grid',
      gridTemplateRows: '1fr',
      gridGap: 134,

      '&.image-from-left': {
        gridTemplateColumns: '5fr 6fr',
        gridTemplateAreas: "'image content'",
      },

      '&.image-from-right': {
        gridTemplateColumns: '6fr 5fr',
        gridTemplateAreas: "'content image'",
      },
      '&[class*=image-from]': {
        [mediaQuery(1023)]: {
          gridTemplateColumns: '1fr',
          gridTemplateAreas: "'image' 'content'",
          gridGap: '0',
        },
      },
    },
    column: {
      minWidth: 0,

      '&.image': {
        gridArea: 'image',
        minHeight: 244,
        width: '100%',
      },
      '&.content': {
        display: 'flex',
        justifyContent: 'center',
        gridArea: 'content',
        width: '100%',
      },

      [mediaQuery(1023)]: {
        maxWidth: 456,
        margin: [Spacings.s0, 'auto'],
      },
    },
    content: {
      width: '100%',

      [mediaQuery(1023)]: {
        maxWidth: 456,
      },
    },

    // skeleton
    titleFallback: {
      width: 150,
      height: 45,
    },
    descriptionFallback: {
      width: 255,
      height: 24,
    },
    actionFallback: {
      width: 120,
      height: 44,
      marginRight: 16,
    },
    descriptionContentFallback: {
      width: '100%',
      height: 300,
    },
    imageRadius: {
      '& > i': {
        borderRadius: '50%',
      },
    },
  }),
  {
    name: 'body-text-with-double-cta',
  },
);
export default useStyles;
